import type { ICampaignPickItemInteraction } from '~/modules/campaign/types';
import type { IThemePageInfo } from '~/types/themePage';

export interface IAssetTemplateStatus {
  isHomePage: boolean;
  isDefaultTemplateByProvider: boolean;
  isOverriddenByGemPages: boolean;
  isThemePageChildren: boolean;
  isUsedByOtherCampaigns: boolean;
  isGPTemplateMadeDefault: boolean;
  usedPageIds: string[];
  totalUsedPageIds: number;
  assignedPageCount: number;
}

export interface IAssetTemplateInteraction extends ICampaignPickItemInteraction {
  hidePageAssigned?: boolean;
}

export type IAssetTemplateDetail = IThemePageInfo;

export enum IProviderTabFilter {
  SHOPIFY = 'SHOPIFY',
  GEMPAGES = 'GEMPAGES',
}
export enum IDisplayModeFilter {
  ALL = 'ALL',
  READY_TO_TEST = 'READY_TO_TEST',
}
export enum ITemplateStatusFilter {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  NEED_REPUBLISHING = 'NEED_REPUBLISHING',
}
